module.exports = __webpack_public_path__ + "plus-2021jump/images/onepiece_06.82f1cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items/onepiece_06.jpg
// module id = ESOk
// module chunks = 0